import FormType from '../../FormType'

const motorTypes = [FormType.fineMotor, FormType.grossMotor]

export default motorTypes



// WEBPACK FOOTER //
// ./src/data/questionnaires/Types/Motor/MotorTypes.ts